<template>
    <el-scrollbar :style="{height: winHeight}">
        <table class="bm-table" style="margin-bottom: 0px">
            <tr class="table-header">
                <td colspan="2" style="text-align: center">Feature Settings</td>
            </tr>
            <!--<tr>-->
                    <!--<td class="bm-table-name">Visual</td>-->
                    <!--<td class="bm-table-ope">-->
                        <!--<el-switch v-model="feature_visual"-->
                                   <!--active-color="#a4b0be"-->
                                   <!--inactive-color="#E4E7ED"></el-switch>-->
                    <!--</td>-->
            <!--</tr>-->
        </table>
        <!--<div v-if="features !== undefined">-->

            <FeatureBar v-for="(item, i) in $store.state.features_data" :index="i" :feature="item" :key="i"></FeatureBar>
        <!--{{$store.state.features_data}}-->
        <!--</div>-->
    </el-scrollbar>
</template>

<script>
    import FeatureBar from "./FeatureBar"

    export default {
        name: "SequenceSetting",
        data() {
            return {
                feature_visual: true,
                winHeight: window.innerHeight - 90 + "px",

            }
        },
        watch: {
            feature_visual(){

            },
            '$store.state.features_data'(val) {
                this.features = val;
                // console.log("features_data", val)
            },
        },
        components: {
            FeatureBar,
        },
        mounted(){
            // console.log("features_data", this.$store.state.features_data)
        }
    }
</script>

<style scoped>
</style>
